/**
 * The onboarding side panel: the three things that happen between this screen and a pouch, and
 * when the card is charged. Each line repeats a promise the landing page makes, in the same words,
 * so nothing here is new to verify.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import "@lattice/tokens/text.stylex";
import { text } from "@lattice/tokens/text.stylex";

/* The same 960px the shell splits at. */
const WIDE = "@media (min-width: 960px)";
const STEPS = [{
  when: "Today",
  what: "Upload your labs and answer a few questions"
}, {
  when: "Within 24 hours",
  what: "A physician reviews and signs your formula"
}, {
  when: "Every month",
  what: "Your pouch arrives, mixed to order"
}];

/**
 * `priceBesideForm` is for a step that states the price next to its own button: below the split the
 * panel then leaves it out, so the figure is not on the screen twice.
 */
export function WhatHappens({
  priceBesideForm = false
}: {
  readonly priceBesideForm?: boolean;
}) {
  return <>
      <p className="x1ghz6dp xqu410z">What happens next</p>
      <ol className="xe8uvvx x1ghz6dp x1717udv x78zum5 xdt5ytf">
        {STEPS.map(step => <li key={step.when} className="x78zum5 xdt5ytf xskm3c9 xp1t01x xez8t42 x13fuv20 x178xt8z">
            <span className="xl4dl4e x1jty25b">{step.when}</span>
            <span>{step.what}</span>
          </li>)}
      </ol>
      <p {...{
      0: {
        className: "x1ghz6dp xl4dl4e x1jty25b x1fzhlzt"
      },
      1: {
        className: "x1ghz6dp xl4dl4e x1jty25b x1fzhlzt x1s85apg x131p6pp"
      }
    }[!!priceBesideForm << 0]}>
        <span className="xzb3lse xqu410z">$175 a month.</span> Charged only after your
        physician approves your formula.
      </p>
    </>;
}